import { User_ChatRoomView } from '@dinosband/bv-main-schema/dist/types'
import { DataCenter_StoreType } from '../abstract'

// const _DEBUG_LOG = process.env.NODE_ENV !== 'production' &&
//                    !!process.env.VUE_APP_MESSENGER_DEBUG_LOG
export const USER_CHAT_ROOM_VIEW_UPDATED = 'user_chat-room-view-updated'

export class User_ChatRoomViews extends DataCenter_StoreType<number, User_ChatRoomView> { // number is chat-room id

  // context: BvDataCenterContext
  // mainStore: MainStore
  // userViews: Map<number, User_ChatRoomView> = new Map()

  // constructor (context: BvDataCenterContext) {
  //   this.context = context
  //   this.mainStore = context.mainStore
  // }

  get clearOnReconnect () { return false }

  async init () {
    await this.retrieveUserViews()
  }

  async updateUerView (userView: User_ChatRoomView) {
    this.set(userView.chatRoomId, userView)
    await this.mainStore.updateUser_ChatRoomView(userView.id, {
      lastMessageId: { set: userView.lastMessageId },
      lastMessageSeq: { set: userView.lastMessageSeq },
    })
    this.publish(userView)
  }

  async createUserView (chatRoomId: number, lastMessageId?: number, lastMessageSeq?: number) {
    if (chatRoomId == null || chatRoomId <= 0) {
      console.error('[createChatRoomView]', 'invalid chatRoomId', chatRoomId)
      return
    }
    let userView = await this.mainStore.upsertUser_ChatRoomView(chatRoomId)
    if (lastMessageId && userView) {
      userView = await this.mainStore.updateUser_ChatRoomView(userView.id, {
        lastMessageId: { set: lastMessageId },
        lastMessageSeq: { set: lastMessageSeq },
      })
    }
    if (!userView) {
      return
    }
    this.set(chatRoomId, userView)
    this.publish(userView)
    return userView
  }

  private async retrieveUserViews () {
    if (!this.mainStore.userId || this.mainStore.userId <= 0) {
      return
    }
    const result = await this.mainStore.readUser_ChatRoomViews(undefined, this.mainStore.userId) ?? []
    result.forEach((i) => this.set(i.chatRoomId, i))
    // this.userViews = result.reduce((prev, i) => prev.set(i.chatRoomId, i), new Map())
    result.forEach((i) => this.publish(i))
  }

  private publish (userView: User_ChatRoomView) {
    this.context.pubsub.publish(USER_CHAT_ROOM_VIEW_UPDATED, userView)
  }

}



/*
if (_DEBUG_LOG &&
    process.env.NODE_ENV !== 'production' &&
    process.env.VUE_APP_MESSENGER_DEBUG_LOG) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as unknown as any)._BEEZVALLEY_ChatRoomUserViews = userViews
}
*/